<ion-menu side="start" menuId="first" contentId="main-content">
  <app-menu [menuItems]='menuItems'></app-menu>
</ion-menu>

<ion-header>
  <ion-toolbar>
    <mat-toolbar color="text-white" class="pb-container pb-toolbar">
      <ion-menu-button [autoHide]="false" menu="first"></ion-menu-button>
      <img class="menu-logo" src="assets-specific/img/logo_grey@3x.png" alt="logo" />
      <nav class="menu-toolbar">
        <ul>
          <li class="ion-margin-right">
            <button [matMenuTriggerFor]="menu" class="profile-button">
              <img src="assets/img/person.png" alt="avatar-icon" />
              <span>{{ userName }}</span>
              <mat-icon aria-hidden="false" class="material-icons--outlined">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>
                <a (click)="logout()">{{ 'general.profile' | translate }}</a>
              </button>
            </mat-menu>
          </li>
          <li>
            <button [class.active]="numberNotifications > 0" [routerLink]="['/notifications']">
              <mat-icon>notifications</mat-icon>
              <span *ngIf="numberNotifications > 0">{{ numberNotifications }}</span>
            </button>
          </li>
        </ul>
      </nav>
    </mat-toolbar>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-page">
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-content>
